package gr.tech.GRAttestation.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.util.TimeUtils
import org.jetbrains.compose.web.css.*


//Stupid bootstrap overwrites Anchor tags with their own. Cant use style
//to rid of underline/blue text color for link. Need to inline style it.
val FooterSectionStyle = CssStyle.base {
    Modifier
        .margin(topBottom = 3.cssRem)
        .padding(topBottom = 1.cssRem, leftRight = 2.percent)
        .fillMaxWidth()
}

val FooterLinkSection = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .gap(2.cssRem)
    }
    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)

    }
}

@Composable
fun FooterLink(tolink: String, Text: String) {
    Link(tolink, FooterLinkStyle.toModifier()
        .textDecorationLine(TextDecorationLine.None)
        .color(Colors.White)) {
        SpanText(Text, FooterTextStyle.toModifier())
    }
}

val FooterLinkStyle = CssStyle.base {
    Modifier
        .textDecorationLine(TextDecorationLine.None)
        .color(Colors.White)
}

val FooterColumnStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(AlignItems.Start)
            .textAlign(TextAlign.Start)
            .gap(3.px)
            .fillMaxWidth()
    }
}

val FooterTitleStyle = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Bold)
            .margin(bottom = 1.cssRem)
            .fontSize(1.2.cssRem)
    }
}

val FooterTextStyle = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Light)
            .fontSize(.9.cssRem)
            .cursor(Cursor.Pointer)
    }
}

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Column(FooterSectionStyle.toModifier().classNames("my-2").then(modifier)) {
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
            SpanText("© ${TimeUtils.getMyLocalDateTimeNow().year}, Green Rebates. All Rights Reserved.")
        }
    }
}
